// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../../shared/components/editable-field';
import {FormattedMessage} from 'react-intl';
import FormattedNumberInput from '../../../../shared/components/formatted-number-input/index';
import LabeledFormInput from '../../../../shared/components/labeled-form-input';
import {buildCurrency} from '../../../../shared/services/build-number';

function handleChange(value) {

    this.onChange(value);

}

const LabeledInput = ({className, errorMessage, isEditable, isValid, value, label, ...props}) => {

    const modifiedClassName = isValid ?
        className :
        `claim-error ${className}`;

    return (
        <LabeledFormInput
            className={modifiedClassName}
            label={label}
        >
            <EditableField
                isEditable={isEditable}
                value={buildCurrency(value)}
            >
                <span>
                    <FormattedNumberInput
                        allowNegative={props.allowNegative}
                        decimalPrecision={props.decimalPrecision}
                        disabled={props.disabled}
                        onBlur={props.onBlur}
                        onValueChange={props::handleChange}
                        value={value}
                    />
                    {isValid ?
                        null :
                        <span className='error-message'>
                            <FormattedMessage id={errorMessage}/>
                        </span>
                    }
                </span>
            </EditableField>
        </LabeledFormInput>
    );

};

LabeledInput.displayName = 'LabeledInput';
LabeledInput.propTypes = {
    allowNegative: PropTypes.bool.isRequired,
    className: PropTypes.string.isRequired,
    decimalPrecision: PropTypes.number.isRequired,
    disabled: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.number
};

export default LabeledInput;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-fields/labeled-currency-input.js